// Toggles the plus/minus symbol in the footer based on if the footer menu is open or closed
jQuery(document).ready(function() {
  var footerPrimaryLink = jQuery("span.usa-footer__primary-link").parent("section");
  if(jQuery(footerPrimaryLink).length) {
    jQuery(footerPrimaryLink).each( function(index) {
      // Temporary Function - Mimics USWDS Footer Accordion function
    jQuery(window).on("resize",function(e){
      if (jQuery(window).width() <= 960) {
        jQuery(footerPrimaryLink).one().addClass('uswds-hidden');
      } else {
        jQuery(footerPrimaryLink).one().removeClass('uswds-hidden');
      }
  });
      var footerPrimarySiblings = jQuery(this).parent("div").siblings().find("section");
      jQuery(this).on("click", function() {
        var footerPrimaryBox = jQuery(this).find("svg");
        var footerPrimarySiblingsSvg = jQuery(footerPrimarySiblings).find("svg");
        if(jQuery(this).is(".hidden, .uswds-hidden")) {
          jQuery(footerPrimaryBox).removeClass("fa-plus-square");
          jQuery(footerPrimaryBox).addClass("fa-minus-square");
          jQuery(footerPrimarySiblingsSvg).removeClass("fa-minus-square");
          jQuery(footerPrimarySiblingsSvg).addClass("fa-plus-square");
          jQuery(this).removeClass('uswds-hidden');
        }
        else {
          jQuery(footerPrimaryBox).addClass("fa-plus-square");
          jQuery(footerPrimaryBox).removeClass("fa-minus-square");
          jQuery(this).addClass('uswds-hidden');
        }
      });
    });
  }
});

// Adds scroll animation to scroll to top
jQuery(document).ready(function () {
  jQuery(".footer-scroll-to-top").hide();
  jQuery(window).scroll(function() {
      if (jQuery(this).scrollTop() > 700) {
          jQuery('.footer-scroll-to-top').fadeIn('slow');
      }
      else {
          jQuery('.footer-scroll-to-top').fadeOut('slow');
      }
  });
  jQuery(".footer-scroll-to-top").on('click', function () {
      jQuery("html, body").animate({scrollTop: 0}, 400);
  });
});